import { render } from "./CompraView.vue?vue&type=template&id=04e3e9a8&scoped=true"
import script from "./CompraView.vue?vue&type=script&lang=js"
export * from "./CompraView.vue?vue&type=script&lang=js"

import "./CompraView.vue?vue&type=style&index=0&id=04e3e9a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e3e9a8"]])

export default __exports__